export class ROUTES {
  public static readonly NOT_FOUND = {
    PATH: '404',
    TITLE: 'Not found',
    BREADCRUMB: 'Not found',
  } as const;

  public static readonly EXTERNAL = {
    PATH: '',
    TITLE: 'Home',
    BREADCRUMB: 'Home',
  } as const;

  public static readonly LOGIN = {
    PATH: 'login',
    TITLE: 'Login',
    BREADCRUMB: 'Login',
  } as const;

  public static readonly DASHBOARD = {
    PATH: 'dashboard',
    TITLE: 'Dashboard',
    BREADCRUMB: 'Dashboard',
  } as const;

  public static readonly SHEET = {
    PATH: 'sheet',
    TITLE: 'Sheet ',
    BREADCRUMB: 'Sheet ',
  } as const;

  public static readonly USERS = {
    PATH: 'users',
    TITLE: 'User management ',
    BREADCRUMB: 'Users ',
  } as const;

  public static readonly PROJECT = {
    PATH: 'project',
    TITLE: 'Sheet ',
    BREADCRUMB: 'PROJECT | Sheet ',
  } as const;

  public static readonly PROJECT_EDIT = {
    PATH: 'edit',
    TITLE: 'Sheet ',
    BREADCRUMB: 'PROJECT | Sheet ',
  } as const;

  public static readonly REGISTER = {
    PATH: 'register',
    TITLE: 'Register',
    BREADCRUMB: 'Register | Sheet',
  } as const;

  public static readonly MANAGE = {
    PATH: 'manage',
    TITLE: 'Datasheet management',
    BREADCRUMB: 'Datasheet management',
  } as const;

  public static readonly STEPS = {
    PATH: 'steps',
    TITLE: 'Steps',
    BREADCRUMB: 'Steps',
  } as const;

  public static readonly SHARE = {
    PATH: 'share',
    TITLE: 'Share',
    BREADCRUMB: 'Share',
  } as const;

  public static readonly GEOMETRY = {
    PATH: 'geometry',
    TITLE: 'Geometry',
    BREADCRUMB: 'Sheet | Geometry',
  } as const;

  public static readonly GLOBAL = {
    PATH: 'global',
    TITLE: 'Global',
    BREADCRUMB: 'Sheet | Global',
  } as const;

  public static readonly SOILS = {
    PATH: 'soils',
    TITLE: 'Soils',
    BREADCRUMB: 'Sheet | Soils',
  } as const;

  public static readonly PIPE_PROPERTIES = {
    PATH: 'cross-section',
    TITLE: 'Cross Section',
    BREADCRUMB: 'Sheet | Cross Section',
  } as const;

  public static readonly ACCESSORIES = {
    PATH: 'accessories',
    TITLE: 'Accessories',
    BREADCRUMB: 'Sheet | Accessory properties',
  } as const;

  public static readonly FLEXLINE = {
    PATH: 'flexible-pipe',
    TITLE: 'Flexible Pipe',
    BREADCRUMB: 'Sheet | Cross Section | Flexible Pipe',
  } as const;

  public static readonly FLEXLINE_GENERAL = {
    PATH: 'general',
    TITLE: 'General',
    BREADCRUMB: 'Sheet | Cross Section | Flexible Pipe | General',
  } as const;

  public static readonly FLEXLINE_UTILIZATION_FACTOR = {
    PATH: 'utilization-factor',
    TITLE: 'Utilization Factor',
    BREADCRUMB: 'Sheet | Cross Section | Flexible Pipe | Utilization Factor',
  } as const;

  public static readonly CONNECTOR = {
    PATH: 'end-fitting',
    TITLE: 'End fitting',
    BREADCRUMB: 'Sheet | Cross Section | End fitting',
  } as const;

  public static readonly RIGIDTUBE = {
    PATH: 'rigid-tube',
    TITLE: 'Rigid Tube',
    BREADCRUMB: 'Sheet | Cross Section | Rigid Tube',
  } as const;

  public static readonly RIGIDTUBE_GENERAL = {
    PATH: 'general',
    TITLE: 'General',
    BREADCRUMB: 'Sheet | Cross Section | Rigid Tube | General',
  } as const;

  public static readonly COATING = {
    PATH: 'coating',
    TITLE: 'Coating',
    BREADCRUMB: 'Sheet | Cross Section | Rigid Tube | Coating',
  } as const;

  public static readonly RIGIDTUBE_UTILIZATION_FACTOR = {
    PATH: 'utilization-factor',
    TITLE: 'Utilization Factor',
    BREADCRUMB: 'Sheet | Cross Section | Rigid Tube | Utilization Factor',
  } as const;

  public static readonly STRESS_JOINT = {
    PATH: 'stress-joint',
    TITLE: 'Stress Joint',
    BREADCRUMB: 'Sheet | Cross Section | Stress Joint',
  } as const;

  public static readonly STRESS_JOINT_GENERAL = {
    PATH: 'general',
    TITLE: 'General',
    BREADCRUMB: 'Sheet | Cross Section | Stress Joint | General',
  } as const;

  public static readonly STRESS_JOINT_UTILIZATION_FACTOR = {
    PATH: 'utilization-factor',
    TITLE: 'Utilization Factor',
    BREADCRUMB: 'Sheet | Cross Section | Stress Joint | Utilization Factor',
  } as const;

  public static readonly CABLE = {
    PATH: 'cable',
    TITLE: 'Cable',
    BREADCRUMB: 'Sheet | Cross Section | Cable',
  } as const;

  public static readonly FLOATER = {
    PATH: 'buoyancy-module',
    TITLE: 'Buoyancy module',
    BREADCRUMB: 'Sheet | Accessory properties | Buoyancy module',
  } as const;

  public static readonly STIFFENER = {
    PATH: 'stiffener',
    TITLE: 'Stiffener',
    BREADCRUMB: 'Sheet | Accessory properties | Stiffener',
  } as const;

  public static readonly STRAKE = {
    PATH: 'strake',
    TITLE: 'Strake',
    BREADCRUMB: 'Sheet | Accessory properties | Strake',
  } as const;

  public static readonly FLEXJOINT = {
    PATH: 'flex-joint',
    TITLE: 'Flex joint',
    BREADCRUMB: 'Cross Section | Accessory properties | Sheet',
  } as const;

  public static readonly LINE = {
    PATH: 'line',
    TITLE: 'Line composition',
    BREADCRUMB: 'Sheet | Line',
  } as const;

  public static readonly LINES = {
    PATH: 'lines',
    TITLE: 'Lines',
    BREADCRUMB: 'Sheet | Lines',
  } as const;

  public static readonly FUNCTIONS = {
    PATH: 'functions',
    TITLE: 'Functions',
    BREADCRUMB: 'Functions',
  } as const;

  public static readonly FLUID_FUNCTION = {
    PATH: 'fluid',
    TITLE: 'Fluid',
    BREADCRUMB: 'Fluid',
  } as const;

  public static readonly FUNCTION_BY_POINTS = {
    PATH: 'by-points',
    TITLE: 'By Points',
    BREADCRUMB: 'By Points',
  } as const;

  public static readonly FUNCTION_HARMONIC = {
    PATH: 'harmonic',
    TITLE: 'Harmonic',
    BREADCRUMB: 'Harmonic',
  } as const;

  public static readonly LINE_SUMMARY = {
    PATH: 'line-summary',
    TITLE: 'Line summary',
    BREADCRUMB: 'Line summary',
  } as const;

  public static readonly SUMMARY = {
    PATH: 'summary',
    TITLE: 'Line summary',
    BREADCRUMB: 'Line summary',
  } as const;

  public static readonly SUMMARY_GLOBAL = {
    PATH: 'global',
    TITLE: 'Global',
    BREADCRUMB: 'Global',
  } as const;

  public static readonly SUMMARY_MESH = {
    PATH: 'mesh',
    TITLE: 'Mesh',
    BREADCRUMB: 'Mesh',
  } as const;

  public static readonly SUMMARY_WEIGHTS = {
    PATH: 'weights',
    TITLE: 'Weights',
    BREADCRUMB: 'Weights',
  } as const;

  public static readonly SUMMARY_CROSS_SECTION = {
    PATH: 'cross-section',
    TITLE: 'Cross section',
    BREADCRUMB: 'Cross section',
  } as const;

  public static readonly SUMMARY_HYDRODYNAMIC_DATA = {
    PATH: 'hydrodynamic-data',
    TITLE: 'Hydrodynamic data',
    BREADCRUMB: 'Hydrodynamic data',
  } as const;

  public static readonly MESH = {
    PATH: 'mesh',
    TITLE: 'Line mesh',
    BREADCRUMB: 'Line mesh',
  } as const;

  public static readonly FLOATING = {
    PATH: 'floating',
    TITLE: 'Floating',
    BREADCRUMB: 'Line bindings | Floating',
  } as const;

  public static readonly CONNECTION = {
    PATH: 'connection',
    TITLE: 'Connection',
    BREADCRUMB: 'Line bindings | Connection',
  } as const;

  public static readonly LOADING = {
    PATH: 'loading',
    TITLE: 'Loading',
    BREADCRUMB: 'Loading',
  } as const;

  public static readonly NODAL_SUPPORT = {
    PATH: 'nodal-support',
    TITLE: 'Nodal Support',
    BREADCRUMB: 'Nodal Support',
  } as const;

  public static readonly RESTRAINTS = {
    PATH: 'restraints',
    TITLE: 'Restraints',
    BREADCRUMB: 'Nodal Support | Restraints',
  } as const;

  public static readonly STIFFNESS = {
    PATH: 'stiffness',
    TITLE: 'Stiffness',
    BREADCRUMB: 'Nodal Support | Stiffness',
  } as const;

  public static readonly ANALYSIS_CASES = {
    PATH: 'analysis-cases',
    TITLE: 'Analysis cases',
    BREADCRUMB: 'Analysis cases',
  } as const;

  public static readonly GENERAL_DATA = {
    PATH: 'general-data',
    TITLE: 'General Data',
    BREADCRUMB: 'Analysis cases | General Data',
  } as const;

  public static readonly FLUID_LOAD = {
    PATH: 'fluid-load',
    TITLE: 'Fluid Load',
    BREADCRUMB: 'Analysis cases | Fluid Load',
  } as const;

  public static readonly ENVIRONMENT_LOAD = {
    PATH: 'environment-load',
    TITLE: 'Environment Load',
    BREADCRUMB: 'Analysis cases | Environment Load',
  } as const;

  public static readonly ANALYSIS_POST_PROCESSING = {
    PATH: 'post-processing',
    TITLE: 'Post Processing',
    BREADCRUMB: 'Analysis cases | Post Processing',
  } as const;

  public static readonly LOADING_CASES = {
    PATH: 'loading-cases',
    TITLE: 'Loading cases',
    BREADCRUMB: 'Loading cases',
  } as const;

  public static readonly WAVES = {
    PATH: 'waves',
    TITLE: 'Waves',
    BREADCRUMB: 'Loading cases | Waves',
  } as const;

  public static readonly WAVES_GROUP = {
    PATH: 'group',
    TITLE: 'Wave Group',
    BREADCRUMB: 'Loading cases | Waves Group',
  } as const;

  public static readonly CURRENTS = {
    PATH: 'currents',
    TITLE: 'Currents',
    BREADCRUMB: 'Loading cases | Currents',
  } as const;

  public static readonly CURRENTS_GROUP = {
    PATH: 'group',
    TITLE: 'Current Group',
    BREADCRUMB: 'Loading cases | Currents Group',
  } as const;

  public static readonly RESULTS = {
    PATH: 'results',
    TITLE: 'Results',
    BREADCRUMB: 'Results',
  } as const;

  public static readonly SELECTION = {
    PATH: 'selection',
    TITLE: 'Selection',
    BREADCRUMB: 'Results | Selection',
  } as const;

  public static readonly TIME_HISTORY = {
    PATH: 'time-history',
    TITLE: 'Time history',
    BREADCRUMB: 'Results | Time history',
  } as const;

  public static readonly ENVELOPES = {
    PATH: 'envelopes',
    TITLE: 'Envelopes',
    BREADCRUMB: 'Results | Envelopes',
  } as const;

  public static readonly FATIGUE = {
    PATH: 'fatigue',
    TITLE: 'Fatigue',
    BREADCRUMB: 'Results | Fatigue',
  } as const;

  public static readonly FATIGUE_LINES = {
    PATH: 'fatigue-lines',
    TITLE: 'Lines',
    BREADCRUMB: 'Results | Fatigue | Lines',
  } as const;

  public static readonly SN_CURVES = {
    PATH: 'sn-curves',
    TITLE: 'SN Curves',
    BREADCRUMB: 'Results | SN Curves',
  } as const;

  public static readonly SN_CURVE_FLEXIBLE_PIPE = {
    PATH: 'sn-curves-for-flexible-pipe',
    TITLE: 'Flexible Pipe',
    BREADCRUMB: 'Results | Fatigue | SN Curves | Flexible Pipe',
  } as const;

  public static readonly SN_CURVE_STEEL_PIPE = {
    PATH: 'sn-curves-for-steel-pipe',
    TITLE: 'Steel Pipe',
    BREADCRUMB: 'Results | Fatigue | SN Curves | Steel Pipe',
  } as const;

  public static readonly SIMULATIONS = {
    PATH: 'simulations',
    TITLE: 'Simulation ',
    BREADCRUMB: 'Anflex WEB - Simulation',
  } as const;

  public static readonly PEAK = {
    PATH: 'peak',
    TITLE: 'Peak',
    BREADCRUMB: 'Peak',
  } as const;

  public static readonly POINT = {
    PATH: 'point',
    TITLE: 'Point',
    BREADCRUMB: 'Point',
  } as const;

  public static readonly GENERAL = {
    PATH: 'general',
    TITLE: 'General',
    BREADCRUMB: 'General',
  } as const;

  public static readonly ASSEMBLY = {
    PATH: 'assembly',
    TITLE: 'Assembly',
    BREADCRUMB: 'Analisys Cases | Assembly',
  } as const;

  public static readonly ASSEMBLY_AMPLITUDE = {
    PATH: 'amplitude',
    TITLE: 'Amplitude',
    BREADCRUMB: 'Analisys Cases | Assembly | Amplitude',
  } as const;

  public static readonly ASSEMBLY_FUNCTION = {
    PATH: 'function',
    TITLE: 'Function',
    BREADCRUMB: 'Analisys Cases | Assembly | Function',
  } as const;

  public static readonly STATIC = {
    PATH: 'static',
    TITLE: 'Static',
    BREADCRUMB: 'Analisys Cases | Static',
  } as const;

  public static readonly STATIC_AMPLITUDE = {
    PATH: 'amplitude',
    TITLE: 'Amplitude',
    BREADCRUMB: 'Analisys Cases | Static | Amplitude',
  } as const;

  public static readonly STATIC_FUNCTION = {
    PATH: 'function',
    TITLE: 'Function',
    BREADCRUMB: 'Analisys Cases | Static | Function',
  } as const;

  public static readonly DYNAMIC = {
    PATH: 'dynamic',
    TITLE: 'Dynamic',
    BREADCRUMB: 'Analisys Cases | Dynamic',
  } as const;

  public static readonly DYNAMIC_GENERAL = {
    PATH: 'general',
    TITLE: 'General',
    BREADCRUMB: 'Analisys Cases | Dynamic | General',
  } as const;

  public static readonly DYNAMIC_PARAMETERS = {
    PATH: 'parameters',
    TITLE: 'Parameters',
    BREADCRUMB: 'Analisys Cases | Dynamic | Parameters',
  } as const;

  public static readonly DYNAMIC_SECOND_ORDER_MOV = {
    PATH: 'second-order-mov',
    TITLE: 'Second Order Mov.',
    BREADCRUMB: 'Analisys Cases | Dynamic | Second Order Movement',
  } as const;

  public static readonly DYNAMIC_AMPLITUDE = {
    PATH: 'amplitude',
    TITLE: 'Amplitude',
    BREADCRUMB: 'Analisys Cases | Dynamic | Amplitude',
  } as const;

  public static readonly DYNAMIC_FUNCTION = {
    PATH: 'function',
    TITLE: 'Function',
    BREADCRUMB: 'Analisys Cases | Dynamic | Function',
  } as const;

  public static readonly REFERENCE_SYSTEM = {
    PATH: 'reference-system',
    TITLE: 'Reference system',
    BREADCRUMB: 'Reference System',
  } as const;

  public static readonly RUN = {
    PATH: 'run',
    TITLE: 'Run simulation',
    BREADCRUMB: 'Run simulation',
  } as const;

  public static readonly RUN_PROGRESS = {
    PATH: 'progress',
    TITLE: 'Progress',
    BREADCRUMB: 'Progress',
  } as const;

  public static readonly RUN_HISTORY = {
    PATH: 'history',
    TITLE: 'History',
    BREADCRUMB: 'History',
  } as const;

  public static readonly POST_PROCESS = {
    PATH: 'post-processing',
    TITLE: 'Post processing',
    BREADCRUMB: 'Post processing',
  } as const;

  public static readonly POST_PROCESS_ENVELOPES = {
    PATH: 'envelopes',
    TITLE: 'Envelopes',
    BREADCRUMB: 'Post processing | Envelopes',
  } as const;

  public static readonly POST_PROCESS_ENVELOPES_SUMMARY = {
    PATH: 'summary',
    TITLE: 'Summary',
    BREADCRUMB: 'Post processing | Envelopes | Summary',
  } as const;

  public static readonly POST_PROCESS_ENVELOPES_PLOTS = {
    PATH: 'plots',
    TITLE: 'Plots',
    BREADCRUMB: 'Post processing | Envelopes | Plots',
  } as const;

  public static readonly POST_PROCESS_TIME_SERIES = {
    PATH: 'time-series',
    TITLE: 'Time series',
    BREADCRUMB: 'Post processing | Time series',
  } as const;

  public static readonly POST_PROCESS_FATIGUE = {
    PATH: 'fatigue',
    TITLE: 'Fatigue',
    BREADCRUMB: 'Post processing | Fatigue',
  } as const;

  public static readonly POST_PROCESS_FATIGUE_FLEX = {
    PATH: 'flexible',
    TITLE: 'Flexible',
    BREADCRUMB: 'Post processing | Fatigue | Flexible',
  } as const;

  public static readonly POST_PROCESS_FATIGUE_STEEL = {
    PATH: 'steel-pipe',
    TITLE: 'Steel Pipe',
    BREADCRUMB: 'Post processing | Fatigue | Steel pipe',
  } as const;
}
